import { Box, Typography } from "@mui/material";
import { isUserAdmin } from "common/userUtils";
import { CurrentUserContext } from "components/context/RequireAuth";
import useIsDesktop from "components/hooks/useIsDesktop";
import useIsMobile from "components/hooks/useIsMobile";
import { Star } from "lucide-react";
import { useContext } from "react";

// Add constant for highlighted report refs
const HIGHLIGHTED_ADVISOR_REPORT_REFS = ["AAAAAAAAAAE=", "AAAAAAAAAB0="];

const HIGHLIGHTED_ADMIN_REPORT_REFS = [
  "AAAAAAAAACM=",
  "AAAAAAAAAAQ=",
  "AAAAAAAAAAU=",
  "AAAAAAAAAAg=",
  "AAAAAAAAAAc=",
  "AAAAAAAAAD8=",
];

export default ({
  reports,
  onSelect,
}: {
  reports: Record<string, { label: string; value: string; type?: string }>;
  onSelect: (ref: string) => void;
}) => {
  const currentUser = useContext(CurrentUserContext);
  const isAdmin = isUserAdmin(currentUser);
  const isMobile = useIsMobile();
  const isDesktop = useIsDesktop();
  const highlights = isAdmin
    ? HIGHLIGHTED_ADMIN_REPORT_REFS
    : HIGHLIGHTED_ADVISOR_REPORT_REFS;

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: "16px",
        alignSelf: "stretch",
        marginBottom: "25px",
      }}
    >
      {highlights.map((ref) => {
        const report = reports[ref];
        if (!report) return null;

        return (
          <Box
            key={ref}
            onClick={() => onSelect(ref)}
            sx={{
              display: "flex",
              flex: isMobile ? undefined : undefined,
              width: isDesktop ? "47%" : "100%",
              padding: "28px 16px",
              alignItems: "center",
              justifyContent: "start",
              cursor: "pointer",
              alignSelf: "stretch",
              border: "1px solid #D4D4D4",
              borderRadius: "12px",
              background: "#FFF",
            }}
          >
            <Box
              display="flex"
              flexDirection="row"
              gap="8px"
              alignItems="center"
              justifyContent="start"
            >
              <Star />
              <Typography
                variant="bodyHeavy"
                sx={{
                  color: "#3D3D3D",
                }}
              >
                {report.label}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};
